export default __webpack_public_path__ + "static/7.Far Eastern-e4f3214aaa427974aabcc80b2f94637a.png";